export default "__VITE_ASSET__CLy3uwcg__"